import { EnrollmentFormService } from 'src/app/services/enrollment/enrollment-form.service';
import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { EnrollmentService } from 'src/app/services/enrollment/enrollment.service';
import { ClientStorageService } from 'src/app/services/client-storage.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScholasticYear } from 'src/app/models/scholastic-year.model';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AppTools } from 'src/app/utils/tools';

export interface EnrollmentsExporterDialogFilters {
  y: string;
  departments?: string[];
  years?: string[];
  types?: string[];
}

@Component({
  selector: 'app-enrollments-exporter-dialog',
  templateUrl: './enrollments-exporter-dialog.component.html',
})
export class EnrollmentsExporterDialogComponent implements OnInit {
  private _enrolmentService: EnrollmentService = inject(EnrollmentService);
  private _enrollmentFormService: EnrollmentFormService = inject(
    EnrollmentFormService
  );
  private _baseComponentService: BaseComponentService =
    inject(BaseComponentService);
  private _clientStorageService: ClientStorageService =
    inject(ClientStorageService);

  public loading: boolean = false;
  public headquarter = this._clientStorageService.getHeadquarterString();
  public scholasticYearsListing: string[] = [];
  public departmentsListing: string[] =
    this._enrollmentFormService.headquartersListing
      .filter((x) => x.value == this.headquarter.toUpperCase())
      .at(0)
      ?.departmentsListing.map((d) => d.title) || [];
  public userTypesListing = [
    { value: 'Student', title: 'Studenti' },
    { value: 'Parent', title: 'Genitori' },
    { value: 'Tutor', title: 'Tutori' },
  ];
  public yearsListing: string[] = ['1', '2', '3', '4', '5'];

  public formGroup: FormGroup = new FormGroup({
    y: new FormControl(),
    years: new FormArray(this.yearsListing.map(() => new FormControl(true))),
    departments: new FormArray(
      this.departmentsListing.map(() => new FormControl(true))
    ),
    types: new FormArray(
      this.userTypesListing.map(() => new FormControl(true))
    ),
  });

  constructor(
    private _dialogRef: MatDialogRef<EnrollmentsExporterDialogComponent>
  ) {}

  ngOnInit(): void {
    this._enrolmentService.getYearsListing().subscribe({
      next: (response) => {
        this.scholasticYearsListing = response.data;
        if (this.scholasticYearsListing.includes(ScholasticYear.getNext())) {
          this.formGroup.patchValue({ y: ScholasticYear.getNext() });
        } else if (
          !this.scholasticYearsListing.includes(ScholasticYear.getNext())
        ) {
          this.formGroup.patchValue({
            y: this.scholasticYearsListing.at(0) || undefined,
          });
        }
      },
      error: (error) => console.error('getYearsListing - ERROR:', error),
    });
  }

  onDismiss() {
    this._dialogRef.close(false);
  }

  onConfirm() {
    this.loading = true;
    const formValue = this.formGroup.value;
    const years = this.yearsListing
      .filter((_, i) => formValue.years[i])
      .map((y) => y.trim());
    const departments = this.departmentsListing
      .filter((_, i) => formValue.departments[i])
      .map((d) => d.trim());
    const types = this.userTypesListing
      .filter((_, i) => formValue.types[i])
      .map((t) => t.value.trim());
    const filters = AppTools.removeNullAndReplaceWithUndefined({
      ...formValue,
      years,
      departments,
      types,
    });
    if (years.length == 0) {
      this._baseComponentService.showErrorDialog({
        title: 'Attenzione',
        message:
          "È necessario selezionare almeno un anno per poter procedere con l'esportazione.",
      });
    } else if (departments.length == 0) {
      this._baseComponentService.showErrorDialog({
        title: 'Attenzione',
        message:
          "È necessario selezionare almeno un dipartimento per poter procedere con l'esportazione.",
      });
    } else if (types.length == 0) {
      this._baseComponentService.showErrorDialog({
        title: 'Attenzione',
        message:
          "È necessario selezionare almeno un tipo di utente per poter procedere con l'esportazione.",
      });
    } else this._dialogRef.close(filters);
    this.loading = false;
  }
}
